export default "__VITE_ASSET__BC4zZ5hx__"